// @flow
/**
  React Context used in Page Editor
*/
import React from 'react';
import type { $Slot } from 'shared/templates/types';
import type { DragObject } from 'shared/components/DragAndDrop';

export type SubcomponentEditor = {
  onClickAdd: Function,
  onClickDelete: Function,
  onClickEdit: Function,
  onClickMove: Function,
  onClickCopy: Function,
}

export type ComponentEditor = SubcomponentEditor & {
  onClickPresets: Function
}

type Context = {
  editing: boolean,
  isBasicUser: boolean,
  onClickAdd: (string, ?number, ?string, ?number) => void,
  onClickEdit: ($Slot, number, ?string) => void,
  onClickPresets: ($Slot, number) => void,
  onClickDelete: ($Slot, number, ?string) => void,
  onClickMove: ($Slot, number, 'UP' | 'DOWN', ?string) => void,
  onClickCopy: ($Slot, number, ?string) => void,
  onDragAndDrop: (string, DragObject, DragObject) => void
}

const EditorContext = React.createContext<Context>({});

export default EditorContext;
